import { GET_AKSI_PERUBAHAN, GET_DASHBOARD_AKSI_PERUBAHAN, GET_DETAIL_AKSI_PERUBAHAN, GET_FILTER_AKSI_PERUBAHAN, RESET_AKSI_PERUBAHAN, RESET_FILTER_AKSI_PERUBAHAN } from "shared/constants/ActionTypes";

const initialState = {
  dataAksiPerubahan: null,
  detail:null,
  filter:null,
  dashboard:null
};

const aksiPerubahanReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_AKSI_PERUBAHAN:
        return {
          ...state,
          dataAksiPerubahan: action.payload,
        };
        case GET_FILTER_AKSI_PERUBAHAN:
          return {
            ...state,
            filter: action.payload,
          };
          case GET_DASHBOARD_AKSI_PERUBAHAN:
            return {
              ...state,
              dashboard: action.payload,
            };
          case RESET_FILTER_AKSI_PERUBAHAN:
            return {
              ...state,
              filter: null,
            };
        case GET_DETAIL_AKSI_PERUBAHAN:
          return {
            ...state,
            detail: action.payload,
          };


  
        default: {
          return state;
        }

        case RESET_AKSI_PERUBAHAN:
          return initialState
  }
};

export default aksiPerubahanReducer;